import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import ArrowUpward from '@material-ui/icons/ArrowUpward'
import BlueCheckbox from 'components/atoms/BlueCheckbox'

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    position: 'relative',
  },
  active: {
    color: theme.palette.primary.main,
  },
  selectable: {
    cursor: 'pointer',
  },
  label: {
    position: 'relative',
    textTransform: 'uppercase',
  },
  arrow: {
    bottom: 2,
    right: -20,
    fontSize: 16,
    position: 'absolute',
    transition: 'all .2s ease',
  },
  arrowDown: {
    transform: 'scaleY(-1)',
  },
  helpText: {
    width: 225,
    fontSize: 14,
    opacity: 0.9,
    textAlign: 'center',
    padding: `${theme.spacing(2)}px`,
    backgroundColor: '#001325',
    '&::after': {
      bottom: -8,
      left: '50%',
      opacity: 0.9,
      content: "''",
      display: 'block',
      position: 'absolute',
      borderBottom: '7px solid black',
      borderLeft: '7px solid transparent',
      borderRight: '7px solid transparent',
      transform: 'translate(-50%, -1px) rotate(180deg)',
    },
  },
  checkboxContainer: {
    display: 'flex',
  },
  checkbox: {
    left: 10,
    top: -15,
    position: 'absolute',
    '&$checkboxChecked': {
      color: '#007bff',
    },
  },
  checkboxChecked: {},
})

const StyledCheckbox = styled(BlueCheckbox)`
margin-left: 20px;
`

class TableHeaderCell extends React.PureComponent {
  state = {
    helpText: '',
    tooltipOpen: false,
  };

  onTooltipOpen = () => {
    const { helpText } = this.props.column
    if (helpText && helpText.length) {
      this.setState({ helpText, tooltipOpen: true })
    }
  };

  onTooltipClose = () => {
    this.setState({ tooltipOpen: false })
  };

  getContent = () => {
    const {
      classes,
      column,
      isActive,
      ascending,
      onBulkSelect,
      bulkSelected,
    } = this.props

    if (column.hideHeader) {
      return <div />
    } else if (column.format === 'checkbox' && !column.label) {
      return (
        <BlueCheckbox checked={bulkSelected} onChange={() => onBulkSelect()} />
      )
    } else if (column.labelAndCheckbox) {
      return (
        <div className={classes.checkboxContainer}>
          <Typography className={classes.label}>
            {column.label}
          </Typography>
          <StyledCheckbox checked={bulkSelected} onChange={() => onBulkSelect()} />
        </div>
      )
    }


    return (
      <Typography className={classes.label}>
        {column.label}
        {isActive && (
          <ArrowUpward
            color="primary"
            className={classNames(
              classes.arrow,
              !ascending && classes.arrowDown
            )}
          />
        )}
      </Typography>
    )
  };

  render() {
    const {
      classes, column, isActive, selectable, onClick
    } = this.props

    const { tooltipOpen } = this.state

    return (
      <div
        onClick={() =>
          selectable &&
          !column.hideHeader &&
          column.field !== 'select' &&
          onClick(column)
        }
        onFocus={this.onMouseOver}
        style={{ maxWidth: column.width, justifyContent: column.align }}
        className={classNames(
          classes.root,
          isActive && classes.active,
          selectable && !column.hideHeader && classes.selectable
        )}>
        <Tooltip
          placement="top"
          enterDelay={500}
          open={tooltipOpen}
          title={this.state.helpText}
          onOpen={this.onTooltipOpen}
          onClose={this.onTooltipClose}
          classes={{ tooltip: classes.helpText }}>
          {this.getContent()}
        </Tooltip>
      </div>
    )
  }
}

TableHeaderCell.defaultProps = {
  bulkSelected: false,
  onBulkSelect: () => { },
}

TableHeaderCell.propTypes = {
  onClick: PropTypes.func,
  column: PropTypes.object,
  isActive: PropTypes.bool,
  classes: PropTypes.object,
  ascending: PropTypes.bool,
  selectable: PropTypes.bool,
  bulkSelected: PropTypes.bool,
  onBulkSelect: PropTypes.func,
}

export default withStyles(styles)(TableHeaderCell)



// WEBPACK FOOTER //
// ./src/components/atoms/TableHeaderCell.js